<template>
  <v-row justify="center">
    <v-dialog v-model='customermodal' max-width="600">
      <v-card>
        <v-toolbar height="73" color="white" class="headlinestyle">
          <v-btn icon @click="cancel()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title><strong>{{title}}</strong></v-toolbar-title>
        </v-toolbar>
        <br />
        <v-container>
          <v-layout row wrap justify-center hidden-sm-and-down >
            <v-flex xs10 sm10 md10 lg10>
              <v-layout row wrap align-center>
                <v-layout justify-center v-if="id">
                  <v-flex xs12 sm11 md11 lg11>
                    <v-text-field v-model="id" label='USER ID' required color="pink lighten-2" readonly filled></v-text-field>
                  </v-flex><v-flex xs12 sm1 md1 lg1></v-flex>
                  <br /><br /><br />
                </v-layout>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm12 md6 lg6 px-3>
                    <v-text-field v-model="username" label='Username' required :rules="[v => !!v || 'กรุณากรอก Username']" style='display:inline;' color="pink lighten-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 px-3>
                    <v-text-field v-model="passworduser" label='Password' required :rules="[v => !!v || 'กรุณากรอก Password']" style='display:inline;' color="pink lighten-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 px-3>
                    <v-text-field v-model="name" label='ชื่อ-สกุล' required :rules="[v => !!v || 'กรุณากรอก ชื่อ-สกุล']" style='display:inline;' color="pink lighten-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 px-3>
                    <v-text-field v-model="tel" label='เบอร์โทร' style='display:inline;' color="pink lighten-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 px-3>
                    <v-text-field v-model="address" label='ที่อยู่' required :rules="[v => !!v || 'กรุณาที่อยู่']" style='display:inline;' color="pink lighten-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 px-3>
                    <v-text-field v-model="location" label='Location' required style='display:inline;' color="pink lighten-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 px-3>
                    <v-layout align-end>
                    <v-text-field v-model="adminref" label='เจ้าหน้าที่ผู้ดูแล' dense required :rules="[v => !!v || 'กรุณากรอกชื่อเจ้าหน้าที่ผู้ดูแล']" style='display:inline;' color="pink lighten-2"></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 px-3>
                    <v-select
                      :items="activeitems"
                      label="สถานะการใช้งาน"
                      item-text="text"
                      item-value="value"
                      v-model="active"
                      dense
                      color="pink lighten-2"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 px-3>
                    <v-select
                      :items="grouppricedatas"
                      label="ตารางราคาสินค้า"
                      item-text="nametext"
                      item-value="_id"
                      v-model="groupprice_id"
                      clearable
                      dense
                      color="pink lighten-2"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout justify-center>
                  <v-flex xs12 sm12 md12 lg12 pt-4 pl-3>
                    <div class="round">
                      <v-layout>
                        <v-flex xs1 sm1 md1 lg1>
                          <input type="checkbox" id="checkbox1" v-model="payment"/>
                          <label for="checkbox1"></label>
                        </v-flex>
                        <v-flex xs9 sm9 md9 lg9><p>การชำระเงิน</p></v-flex>
                      </v-layout>
                    </div>
                    <div class="round">
                      <v-layout>
                        <v-flex xs1 sm1 md1 lg1>
                          <input type="checkbox" id="checkbox2" v-model="claim"/>
                          <label for="checkbox2"></label>
                        </v-flex>
                        <v-flex xs9 sm9 md9 lg9><p>เคลมสินค้า</p></v-flex>
                      </v-layout>
                    </div>
                    <div class="round">
                      <v-layout>
                        <v-flex xs1 sm1 md1 lg1>
                          <input type="checkbox" id="checkbox3" v-model="can_order"/>
                          <label for="checkbox3"></label>
                        </v-flex>
                        <v-flex xs9 sm9 md9 lg9><p>สั่งสินค้า</p></v-flex>
                      </v-layout>
                    </div>

                  </v-flex>
                </v-layout>
                <br />
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-center hidden-md-and-up >
            <v-flex xs10 sm10 md10 lg10>
              <v-layout row wrap align-center>
                <v-flex xs12 sm12 md11 lg11 v-if="id">
                  <v-text-field v-model="id" label='USER ID' required color="pink lighten-2" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3 class="pr-3">
                  <v-text-field v-model="username" label='Username' required :rules="[v => !!v || 'กรุณากรอก Username']" style='display:inline;' color="pink lighten-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3 class="pr-3">
                  <v-text-field v-model="name" label='ชื่อ-สกุล' required :rules="[v => !!v || 'กรุณากรอก ชื่อ-สกุล']" style='display:inline;' color="pink lighten-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3 class="pr-3">
                  <v-text-field v-model="passworduser" label='Password' required :rules="[v => !!v || 'กรุณากรอก Password']" style='display:inline;' color="pink lighten-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3 class="pr-3">
                  <v-text-field v-model="tel" label='เบอร์โทร' style='display:inline;' color="pink lighten-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3 class="pr-3">
                  <v-text-field v-model="address" label='ที่อยู่' required :rules="[v => !!v || 'กรุณาที่อยู่']" style='display:inline;' color="pink lighten-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3 class="pr-3">
                  <v-text-field v-model="adminref" label='เจ้าหน้าที่ผู้ดูแล' required :rules="[v => !!v || 'กรุณากรอกชื่อเจ้าหน้าที่ผู้ดูแล']" style='display:inline;' color="pink lighten-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 lg3 class="pr-3">
                  <v-text-field v-model="location" label='Location' required style='display:inline;' color="pink lighten-2"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md7 lg7 class="pr-3">
                  <v-select
                    :items="grouppricedatas"
                    label="ตารางราคาสินค้า"
                    item-text="nametext"
                    item-value="_id"
                    dense
                    v-model="groupprice_id"
                    color="pink lighten-2"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md7 lg7 class="pr-3">
                  <v-select
                    :items="activeitems"
                    label="สถานะการใช้งาน"
                    item-text="text"
                    item-value="value"
                    v-model="active"
                    color="pink lighten-2"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3 md3 lg3>
                  <div class="round">
                    <v-layout>
                      <v-flex xs3 sm3 md3 lg3>
                        <input type="checkbox" id="checkbox1" v-model="payment"/>
                        <label for="checkbox1"></label>
                      </v-flex>
                      <v-flex xs9 sm9 md9 lg9><p>การชำระเงิน</p></v-flex>
                    </v-layout>
                  </div>
                  <div class="round">
                    <v-layout>
                      <v-flex xs3 sm3 md3 lg3>
                        <input type="checkbox" id="checkbox2" v-model="claim"/>
                        <label for="checkbox2"></label>
                      </v-flex>
                      <v-flex xs9 sm9 md9 lg9><p>เคลมสินค้า</p></v-flex>
                    </v-layout>
                  </div>
                </v-flex><v-flex xs12 sm1 md1 lg1></v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn color="pink" style="margin-right: 5px" outlined @click="cancel()">ยกเลิก</v-btn>

          <v-btn color="pink lighten-2" dark @click="save()">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { sync } from 'vuex-pathify'
import axios from 'axios'
import swal from 'sweetalert'
export default {
  data () {
    return {
      title: 'เพิ่มร้านค้า',
      currentdata: '',
      id: '',
      username: '',
      name: '',
      passworduser: '',
      passwordadmin: 'adminpass',
      address: '',
      tel: '',
      groupprice_id: '',
      payment: false,
      claim: false,
      can_order: false,
      grouppricedatas: [],
      radios: [],
      adminref: '',
      activeitems: [{ text: 'active', value: true }, { text: 'inactive', value: false }],
      active: true,
      location: ''
    }
  },
  props: {
    // eslint-disable-next-line vue/require-prop-type-constructor
    parentgetdata: ''
  },
  methods: {
    async save () {
      try {
        if (this.username && this.name && this.passworduser && this.passwordadmin && this.address && this.adminref) {
          let tempdata = {
            username: this.username,
            name: this.name,
            password: this.passworduser,
            password_admin: this.passwordadmin,
            address: this.address,
            tel: this.tel,
            groupprice_id: this.groupprice_id,
            status: 'customer',
            payment: this.payment,
            claim: this.claim,
            can_order: this.can_order,
            adminref: this.adminref,
            active: this.active,
            location: this.location
          }

          let swaltext = ''
          if (this.currentdata !== '') {
            await this.axios.put(`${process.env.VUE_APP_API}/user/edit/`, { ...tempdata, userid: this.id }, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            swaltext = 'บันทึกการแก้ไขข้อมูลร้านค้าเรียบร้อย'
          } else {
            let { data } = await this.axios.post(`${process.env.VUE_APP_API}/user/create`, tempdata, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            swaltext = 'บันทึกข้อมูลร้านค้าใหม่เรียบร้อย'
            if (data.message === 'Create user successfully.') {
              this.resetdata()
            }
          }
          this.customermodal = false
          await swal(swaltext, {
            icon: 'success',
            buttons: 'ตกลง'
          })
          this.parentgetdata()
        } else {
          await swal({
            title: `กรุณากรอกข้อมูลร้านค้าให้ครบถ้วน`,
            icon: 'warning',
            buttons: 'ตกลง',
            dangerMode: true
          })
        }
      } catch (error) {
        if (error.response.status === 400) {
          await swal({
            title: `Username นี้มีอยู่แล้วในระบบ`,
            icon: 'warning',
            buttons: 'ตกลง',
            dangerMode: true
          })
        } else {
          await swal({
            title: `ระบบผิดพลาด`,
            text: 'กรุณาลองอีกครั้งในภายหลัง',
            icon: 'warning',
            buttons: 'ตกลง',
            dangerMode: true
          })
        }
      }
    },
    async getselectedata () {
      try {
        let { data } = await axios.get(`${process.env.VUE_APP_API}/groupprice/get/list`, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.grouppricedatas = data.map(gp => {
          return {
            ...gp,
            nametext: `(${gp.groupprice_no}) ${gp.name}`
          }
        })
      } catch (error) {
      }
    },
    cancel () {
      this.currentcustomerdata = ''
      this.customermodal = false
    },
    resetdata () {
      this.username = ''
      this.name = ''
      this.passworduser = ''
      this.address = ''
      this.tel = ''
      this.groupprice_id = ''
      this.payment = false
      this.claim = false
      this.can_order = false
      this.adminref = ''
      this.active = true
      this.location = ''
    }
  },
  computed: {
    customermodal: sync('customermodal'),
    currentcustomerdata: sync('currentcustomerdata')
  },
  watch: {
    currentcustomerdata () {
      if (this.currentcustomerdata !== '') {
        this.currentdata = JSON.parse(this.currentcustomerdata)
        this.id = this.currentdata._id
        this.username = this.currentdata.username
        this.name = this.currentdata.name
        this.passworduser = this.currentdata.password
        this.passwordadmin = this.currentdata.password_admin
        this.address = this.currentdata.address
        this.tel = this.currentdata.tel
        this.groupprice_id = this.grouppricedatas.filter(gp => gp._id === this.currentdata.groupprice_id)[0]
        this.title = `แก้ไขร้านค้า`
        this.payment = this.currentdata.payment
        this.claim = this.currentdata.claim
        this.can_order = this.currentdata.can_order
        this.adminref = this.currentdata.adminref
        this.active = this.currentdata.active
        this.location = this.currentdata.location
      } else {
        this.currentdata = ''
        this.id = ''
        this.username = ''
        this.name = ''
        this.passworduser = ''
        this.passwordadmin = 'adminpass'
        this.address = ''
        this.tel = ''
        this.groupprice_id = ''
        this.title = 'เพิ่มร้านค้า'
        this.payment = false
        this.claim = false
        this.can_order = false
        this.adminref = ''
        this.active = true
        this.location = ''
      }
    }
  },
  mounted () {
    this.getselectedata()
  }
}
</script>
<style>
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.inputstyle {
  font-style: normal;
  font-weight: normal;
}
.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 2px solid #929192;
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  left: 0;
  position: absolute;
  top: 4px;
  width: 20px;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 2px;
  opacity: 0;
  position: absolute;
  top: 4.5px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #FA8072;
  border-color: #EE5787;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

.v-text-field {
    font-family: 'Kanit';
}

.v-btn {
    font-family: 'Kanit';
    font-weight: bold;
}

p {
    font-family: 'Kanit';
}
.v-list-item__title {
  font-family: 'Kanit';
}
</style>
